import React, { Suspense, useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { vasthuUrl } from "../component/Api";
import ServiceList from "../component/serviceList";
import { useTranslation } from "react-i18next";
import HelmetSeo from "../component/HelmetSeo";

const CustomerOneTimePricing = (params) => {
  const token = window.sessionStorage.getItem("token");
  const role = window.sessionStorage.getItem("role");
  const crmUuid = params && params.crmUuid;
  const uuid =
    role === "ROLE_CRM" ? crmUuid : window.sessionStorage.getItem("userId");
  const { t } = useTranslation();
  const [oneTimeIndividual, setOneTimeIndividual] = useState([]);
  console.log("params", params);
  console.log("uuid", uuid);

  const fetchOffers = async () => {
    try {
      const url =
        params &&
        params.selectService !== null &&
        params.selectService !== undefined
          ? `offer/getalluseractiveoffers/${uuid}/${params.selectService}`
          : `offer/getalluseractiveoffer/${uuid}`;

      const response = await vasthuUrl.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setOneTimeIndividual(response.data);
      console.log(response.data);
    } catch (e) {
      console.error("SERVER ERROR", e);
      setOneTimeIndividual([]);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, [params, uuid, token]);

  return (
    <Suspense fallback={<Spinner />}>
      <HelmetSeo
        title="Customer One-Time Service - Quick Vasthu Consultation | Vasthuparam"
        name="description"
        content="Book a one-time Vasthu consultation with Vasthuparam. Perfect for quick validations, land checks, Vedic astrology or house energy assessments at an affordable price."
        relCa="canonical"
        hrefCa="https://www.vasthuparam.com/customonetimeservice"
        relAl="alternate"
        hrefAl="https://m.www.vasthuparam.com/customonetimeservice"
      />

      <Container
        fluid
        style={{
          padding: 20,
          background: "linear-gradient(90deg, #ffbb33 0%, #ffbb33 100%)",
        }}
      >
        <div className=" my-1 g-1">
          <center>
            <h2>{t("USR.PR.OTTAB.TL1")}</h2>
          </center>
          {oneTimeIndividual.length > 0 ? (
            <Suspense fallback={<Spinner />}>
              <ServiceList data={oneTimeIndividual} crmUuid={crmUuid} />
            </Suspense>
          ) : (
            <center>
              <h3>{t("USR.PR.OTTAB.HTXT1")}</h3>
            </center>
          )}
        </div>
        {/* <div className="mt-2 g-1">
          <center>
            <h2>{t("USR.PR.OTTAB.TL2")}</h2>
          </center>
          <Suspense fallback={<Spinner />}>
            {oneTimeCombo.length > 0 ? (
              <ServiceList data={oneTimeCombo} />
            ) : (
              <center>
                <h3>{t("USR.PR.OTTAB.HTXT2")}</h3>
              </center>
            )}
          </Suspense>
        </div> */}
        {/* <ServiceList data={periodicCombo} />
        <ServiceList data={periodicIndividual} /> */}
      </Container>
    </Suspense>
  );
};
export default CustomerOneTimePricing;
